// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gauge_gauge_text_normal__60OVk {
  color: black;
}

.Gauge_gauge_text_down__1G-QO {
  color: red;
}

.Gauge_gauge_text_up__R8YdK {
  color: green;
}

.Gauge_gauge_svg_color_size__-2Al- {
  width: 20px;
  height: 20px;
}

.Gauge_gauge_svg_color_up__v3rd3 {
  fill: green;
  stroke: green;
}

.Gauge_gauge_svg_color_down__zLb7I {
  fill: red;
  stroke: red;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Ventas/Gauges/Gauge.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,SAAS;EACT,WAAW;AACb","sourcesContent":[".gauge_text_normal {\n  color: black;\n}\n\n.gauge_text_down {\n  color: red;\n}\n\n.gauge_text_up {\n  color: green;\n}\n\n.gauge_svg_color_size {\n  width: 20px;\n  height: 20px;\n}\n\n.gauge_svg_color_up {\n  fill: green;\n  stroke: green;\n}\n\n.gauge_svg_color_down {\n  fill: red;\n  stroke: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gauge_text_normal": `Gauge_gauge_text_normal__60OVk`,
	"gauge_text_down": `Gauge_gauge_text_down__1G-QO`,
	"gauge_text_up": `Gauge_gauge_text_up__R8YdK`,
	"gauge_svg_color_size": `Gauge_gauge_svg_color_size__-2Al-`,
	"gauge_svg_color_up": `Gauge_gauge_svg_color_up__v3rd3`,
	"gauge_svg_color_down": `Gauge_gauge_svg_color_down__zLb7I`
};
export default ___CSS_LOADER_EXPORT___;
